/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorProvisionalConfig } from '../../config/error.config';
export interface IErrorProvisionalPluginMethods extends IPluginMethodMap {
  getErrorProvisionalSync(args?: any): any;
}

export class ErrorProvisionalPlugin implements IAgentPlugin {
  readonly methods: IErrorProvisionalPluginMethods;

  constructor() {
    this.methods = {
      getErrorProvisionalSync: this.getErrorProvisionalSync.bind(this),
    };
  }

  getErrorProvisionalSync(args?: any) {
    return {
      error: errorProvisionalConfig,
    };
  }
}
